import { memo, useId } from 'react';

import cls from './input-toggle.module.css';

interface InputToggleProps {
    isChecked?: boolean;
    onChange?: (isChecked: boolean) => void;
    className?: string;
    children?: React.ReactNode;
    isDisabled?: boolean;
}

export const InputToggle = memo((props: InputToggleProps) => {
    const {
        className,
        children,
        isChecked,
        onChange,
        isDisabled,
        ...otherProps
    } = props;
    const id = useId();

    const handleToggleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(e.target.checked);
    };

    return (
        <label
            className={`${cls.toggle} ${className || ''}`}
            htmlFor={id}
        >
            <input
                checked={isChecked}
                className={cls.input}
                disabled={isDisabled}
                id={id}
                onChange={handleToggleChange}
                type="checkbox"
                {...otherProps}
            />
            <span className={cls.switch} />
            {children && <span className={cls.label}>{children}</span>}
        </label>
    );
});

InputToggle.displayName = 'InputToggle';
